import { usersApi } from 'entities/users';
import { MechanicsListType } from 'shared/types';
import { getMechanicsQueryType } from 'features/getMechanics/types';
import { getMechanicsUrlConfig } from 'features/getMechanics/lib/helpers';

const getMechanicsApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getMechanics: builder.query<MechanicsListType, getMechanicsQueryType>({
      query: ({ isActive, size }) => getMechanicsUrlConfig({ isActive, size }),
    }),
  }),
});

export const { useGetMechanicsQuery } = getMechanicsApi;
